import { put, takeLatest } from "redux-saga/effects";
import {
  SIGN_UP_ACTION,
  SIGN_UP_ACTION_INIT,
  SIGN_UP_ACTION_SUCCESS,
  SIGN_UP_ACTION_FAILED,
  IS_COMPANY_NAME_EXIST_ACTION,
  IS_COMPANY_NAME_EXIST_INIT,
  IS_COMPANY_NAME_EXIST_SUCCESS,
  IS_COMPANY_NAME_EXIST_FAILED,
  EMAIL_EXIST,
  EMAIL_EXIST_INIT,
  EMAIL_EXIST_SUCCESS,
  EMAIL_EXIST_FAILED,
  IS_COOPRATIVE_EMAIL_INIT,
  IS_COOPRATIVE_EMAIL_SUCCESS,
  IS_COOPRATIVE_EMAIL_FAILED,
  IS_COOPRATIVE_EMAIL,
} from "./constants";
import { postUtil } from "../../../services/axiosClient";
import { API } from "../../../utils/Constant";

export function* signupCall({ payload, onSuccess }) {

  yield put({ type: SIGN_UP_ACTION_INIT });
  try {
    payload.officePhoneNumber = payload.officePhoneNumber?.length > 3 ? payload.officePhoneNumber : null; 
    payload.phoneNumber = payload.phoneNumber?.length > 3 ? payload.phoneNumber : null; 

    const res = yield postUtil(`${API.signUp}`, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: SIGN_UP_ACTION_SUCCESS, payload: data.result });
      onSuccess();
    } else {
      yield put({ type: SIGN_UP_ACTION_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* isCompanyNameExist({ payload, onChangeCompanySuccess }) {
  yield put({ type: IS_COMPANY_NAME_EXIST_INIT });
  try {
    const res = yield postUtil(`${API.companyExist}?name=${payload}`);
    if (res?.status === 200) {
      const { data } = res;
      onChangeCompanySuccess(data.result);

      yield put({ type: IS_COMPANY_NAME_EXIST_SUCCESS, payload: data.result });
    } else {
      yield put({ type: IS_COMPANY_NAME_EXIST_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* isEmailExist({ payload, onChangeEmailSuccess }) {
  yield put({ type: EMAIL_EXIST_INIT });
  try {
    const res = yield postUtil(`${API.EmailExist}?email=${payload}`);
    if (res?.status === 200) {
      const { data } = res;
      onChangeEmailSuccess(data.result);

      yield put({ type: EMAIL_EXIST_SUCCESS, payload: data.result });
    } else {
      yield put({ type: EMAIL_EXIST_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* isCompanyCooperativeEmail({ payload, onChangeSuccess }) {
  yield put({ type: IS_COOPRATIVE_EMAIL_INIT });
  try {
    const res = yield postUtil(`${API.cooperativeEmail}?email=${payload}`);
    if (res?.status === 200) {
      const { data } = res;
      onChangeSuccess(data.result);

      yield put({ type: IS_COOPRATIVE_EMAIL_SUCCESS, payload: data.result });
    } else {
      yield put({ type: IS_COOPRATIVE_EMAIL_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}


export function* signup() {
  yield takeLatest(SIGN_UP_ACTION, signupCall);
  yield takeLatest(IS_COMPANY_NAME_EXIST_ACTION, isCompanyNameExist);
  yield takeLatest(EMAIL_EXIST, isEmailExist);
  yield takeLatest(IS_COOPRATIVE_EMAIL, isCompanyCooperativeEmail);

}
